<template>
  <h1>404</h1>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue